import axios from "axios";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Document, Page } from "react-pdf/dist/entry.webpack";
import "react-pdf/dist/Page/AnnotationLayer.css";

class ViewPdf extends Component {
  state = {
    numPages: null,
    data: null,
  };

  componentDidMount() {
    const { pdf_url: pdfUrl } = this.props;
    axios.get(pdfUrl).then((res) => {
      const { data } = res;
      this.setState({ data });
    });
  }

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages });
  };

  render() {
    const { numPages, data } = this.state;

    return (
      <div>
        <Document file={data} onLoadSuccess={this.onDocumentLoad}>
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              className="cv__canvas--unset-height"
            />
          ))}
        </Document>
      </div>
    );
  }
}

ViewPdf.propTypes = {
  pdf_url: PropTypes.string.isRequired,
};

export default ViewPdf;
